import { useEffect } from "react";
import { useState, useRef } from "react";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";

import { cuteToast } from "../../UI/cute";
import Input from "../../UI/Input";

const ForgotPassword = ({ onBackToLogin }) => {
  const [email, setEmail] = useState();
  const [isValid, setIsvalid] = useState(null);
  const emailRef = useRef();

  const {
    error,
    setError,
    status: httpStatusCode,
    sendRequest: forgotPasswordRequest,
  } = useHttp();

  const emailChange = (event) => {
    if (event.target.value.trim().length > 0) {
      setEmail(event.target.value.trim());
      setIsvalid(true);
    } else {
      setIsvalid(false);
    }
  };

  const responseData = (response) => {
    cuteToast({
      type: "success",
      message: response.message,
      timer: 5000,
      title: "",
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (isValid) {
      forgotPasswordRequest(
        {
          url: endPoints.forgot_password,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
          },
          body: { email },
        },
        responseData
      );
    } else {
      emailRef.current.focus();
    }
  };

  useEffect(() => {
    if (error && httpStatusCode) {
      cuteToast({
        type: "error",
        message: error,
        timer: 5000,
        title: "",
      });

      setError(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <form onSubmit={handleSubmit}>
      {/* Hidden elements for old layout compat */}
      <h1>Forgot Password</h1>
      <span>
        Please enter your email address below and we will send you information
        to change your password.
      </span>

      {/* Redesigned field */}
      <div className="auth-field">
        <label>Email Address</label>
        <Input
          ref={emailRef}
          type="email"
          placeholder="name@company.com"
          onChange={emailChange}
          inputClass={`${isValid === false ? "invalid" : ""}`}
        />
      </div>

      <button type="submit" className="auth-submit-btn">Send Reset Link</button>

      {onBackToLogin && (
        <button
          type="button"
          className="auth-back-link"
          onClick={onBackToLogin}
        >
          &larr; Back to Sign In
        </button>
      )}
    </form>
  );
};

export default ForgotPassword;
